import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import SignUpPage from 'pages/authorization/signUp';
import LetterSendingPage from 'pages/authorization/passwordReset/LetterSendingPage';
import LoginPage from 'pages/authorization/login';
import InvitationPage from 'pages/invitation';
import PasswordResetPage from 'pages/authorization/passwordReset';
import AccountRestore from 'pages/authorization/accountRestore';
import ModalsController from 'components/modalsController';
import config from 'constants/config';

const LOGIN_PATHS = ['/login', '/sign-up', '/reset-letter', '/password/reset', '/restore'];

const LoginLayout = () => {
  const [emailRstValue, setRstEmail] = useState('');
  const history = useHistory();

  useEffect(() => {
    if (!LOGIN_PATHS.some((p) => window.location.pathname.startsWith(p))) {
      history.replace('/login');
    }
  }, [history]);

  return (
    <GoogleOAuthProvider clientId={config.googleClientId}>
      <Switch>
        <Route path="/sign-up" component={SignUpPage} />
        <Route path="/reset-letter" component={LetterSendingPage} />
        <Route exact path="/restore/:email/:token" component={AccountRestore} />
        <Route exact path="/login" render={() => <LoginPage emailFormData={setRstEmail} />} />
        <Route exact path="/login/invitation" component={InvitationPage} />
        <Route
          exact
          path="/password/reset"
          render={(props) => (
            <PasswordResetPage match={props.match} history={props.history} emailRstValue={emailRstValue} />
          )}
        />
        <Route exact path="/password/reset/:token" component={PasswordResetPage} />
        <Redirect to="/login" />
      </Switch>
      <ModalsController />
    </GoogleOAuthProvider>
  );
};

export default LoginLayout;
